import {
  getProcessorsAll,
  getCurrentProcessor,
  getFilteredProcessors,
  getProcessorStats,
} from '../api/ProcessorApi';
import useBaseQuery from '../hooks/useBaseQuery';
import {
  IBaseQueryOptions,
  IProcessorItemData,
  IProcessor,
  AdminFilters,
  FilteredProcessors,
  ProcessorStats,
} from '../types';
import IQueryKeys from '../types/IQueryKeys';

export const useProcessorsAllQuery = (
  ids?: string | null,
  options?: IBaseQueryOptions<IProcessor>,
) => {
  return useBaseQuery([IQueryKeys.processorAllKey, ids], () => getProcessorsAll(ids!), {
    enabled: ids !== null,
    ...options,
  });
};

export const useCurrentProcessor = (options?: IBaseQueryOptions<IProcessorItemData>) => {
  return useBaseQuery([IQueryKeys.processorInfoKey], () => getCurrentProcessor(), { ...options });
};

export const useFilteredProcessors = (
  filters: AdminFilters,
  options?: IBaseQueryOptions<FilteredProcessors>,
) => {
  return useBaseQuery(
    [IQueryKeys.filteredProcessorsKey, filters],
    () => getFilteredProcessors(filters),
    {
      ...options,
    },
  );
};
export const useProcessorStats = (id: number, options?: IBaseQueryOptions<ProcessorStats>) => {
  return useBaseQuery([IQueryKeys.processorsStatsKey, id], () => getProcessorStats(id), {
    ...options,
  });
};
